import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "HOME", path: "/" },
    { label: "CONTACT", path: "/contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="w-full px-8 py-4 flex items-center">
        <Link to="/" className="flex-shrink-0 mr-10">
          <img
            src={
              scrolled
                ? "https://static.readdy.ai/image/f2900c2528a4254aaaa835833b37ece2/6dde6c7c10a44a50782dc525ebf6d271.png"
                : "https://static.readdy.ai/image/f2900c2528a4254aaaa835833b37ece2/7aca10b927ce0bda8352abc447076316.png"
            }
            alt="Mastro Minds, LLC"
            className="h-12 w-auto object-contain"
          />
        </Link>
        <div className="flex items-center gap-2">
          {navLinks.map((link, index) => (
            <span key={link.path} className="flex items-center">
              <Link
                to={link.path}
                className={`text-sm font-semibold tracking-widest transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? location.pathname === link.path
                      ? "text-gray-900"
                      : "text-gray-500 hover:text-gray-900"
                    : location.pathname === link.path
                    ? "text-white"
                    : "text-white/70 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
              {index < navLinks.length - 1 && (
                <span className={`mx-3 text-sm ${scrolled ? "text-gray-400" : "text-white/50"}`}>/</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </nav>
  );
}
